import Side from './Side';

export default class StandardOutdoorSide extends Side {
  constructor(threekitApi, options = {}) {
    super(threekitApi, options);
    this._key = 'standard_outdoor';
  }
}
